import React, { useState } from "react";
import { Avatar } from "components/avatar";
import { Menu } from "components/menu";
import { Link } from "components/link";
import { Switch, Route, useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import Axios from "axios";
import { useAuthContext } from "contexts/auth";
import { useTranslation } from "react-i18next";
import Personal from "./components/personal";
import Password from "./components/password";
import Accessibility from "./components/accessibility";
import { TbAccessible, TbPassword, TbUser } from "react-icons/tb";

export default function Profile() {
  const { t } = useTranslation();
  const tBase = "views.profile.index";
  const tr = (key) => t(`${tBase}.${key}`);

  const { user_id } = useAuthContext();

  const [name, setName] = useState("");

  const { data: userInfo, refetch } = useQuery(
    "getUserInfo",
    () =>
      Axios.get(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/users/${user_id}`
      ).then((res) => res.data),
    {
      onSuccess: (data) => {
        setName(`${data.first_name} ${data.last_name}`);
      },
      onError: () => console.error("Error fetching user info"),
    }
  );

  const location = useLocation();

  const iconStyle = "-ml-1 text-secondary";

  return (
    <div className="p-4">
      {/* User Avatar */}
      <Avatar size="large" user_id={user_id} showLabel>
        {name}
      </Avatar>

      <div className="flex mt-2 space-x-2">
        {/* Sidebar Menu */}
        <Menu style={{ flex: "0 0 250px", marginRight: "1rem" }}>
          <Link 
            to="/profile/general" 
            selected={location.pathname === "/profile/general"}
          >
            <TbUser size={24} className={iconStyle} />
            {tr("General")}
          </Link>
          <Link 
            to="/profile/password" 
            selected={location.pathname === "/profile/password"}
          >
            <TbPassword size={24} className={iconStyle} />
            {tr("Password")}
          </Link>
          <Link
            to="/profile/accessibility"
            selected={location.pathname === "/profile/accessibility"}
          >
            <TbAccessible size={24} className={iconStyle} />
            {tr("Accessibility")}
          </Link>
        </Menu>

        {/* Main Content */}
        <div className="flex-1">
          <Switch>
            <Route exact path="/profile/general">
              <Personal
                userInfo={userInfo}
                refetchUserInfo={refetch}
                onUpdateName={setName}   
              />
            </Route>
            <Route path="/profile/password">
              <Password />
            </Route>
            <Route path="/profile/accessibility">
              <Accessibility userInfo={userInfo} refetchUserInfo={refetch} />
            </Route>
          </Switch>
        </div>

      </div>
    </div>
  );
}
